 <template>
  <div class="user-list bg-white">
    <el-input placeholder="请输入用户昵称" v-model="name" class="search-bar" prefix-icon="el-icon-search" @change="getMessageList(name)">
    </el-input>
    <div class="list">
      <div class="item" v-for="(item,index) in messageList" :key="index" @click="selectUser(index)">
        <img class="item-avatar" :src="item.logo||require('@/assets/image/avator/LOGO.png')" alt="">
        <div class="item-msg">
          <div class="flex-between flex-center-center mb-20">
            <div class="name">{{item.name}}</div>
            <div class="time">{{item.msgEntity&&timeText(item.msgEntity.createTime)}}</div>
          </div>
          <div class="item-bottom flex-body-line">
            {{msgText(item.msgEntity)}}
          </div>
        </div>
        <div class="item-unread" v-if="item.unReadCount">{{item.unReadCount}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeUnread } from '@/api/im.js';
import { mapActions, mapGetters } from 'vuex';
export default {
  name:'Navbar',
  data() {
    return {
      name:''
    }
  },
  async created () {
    if(!this.messageList){
      await this.getMessageList(this.name)
    }
    if(!this.messageList.length){
      return
    }
    this.selectUser(0)
  },
  computed: {
    ...mapGetters([
      'messageList','currentId','userInfo'
    ])
  },
  methods: {
    ...mapActions(['updateCurrentInfo','getMessageList']),
    async selectUser(index){
      let {userId,name,logo} = this.messageList[index]
      try	{
        await changeUnread(userId, this.userInfo.shop);
        this.getMessageList(this.name)
      } catch(err){
        console.log(err)
      }
      try	{
        await this.updateCurrentInfo({id:userId,name,logo})
      } catch(err){
        console.log(err)
      }
    },
    timeText(time){
      if(!time){
        return ''
      }
      function formatNumber(val){
        return ('0'+val).slice(-2)
      }
      let date = new Date(time)
      let today = new Date()
      let year = (date.getFullYear()) 
      let month = formatNumber(date.getMonth() + 1)
      let day = formatNumber(date.getDate())
      let h = formatNumber(date.getHours())
      let m = formatNumber(date.getMinutes())
      if(date.getFullYear()!==today.getFullYear()){
        return `${year}-${month}-${day} ${h}:${m}`
      }
      if(date.getMonth()!==today.getMonth()||date.getDate()!==today.getDate()){
        return `${month}-${day} ${h}:${m}`
      }
      if((today.getTime()-date.getTime())<=5*60*1000){
        return "刚刚"
      }
      return `今天${h}:${m}`
    },
    msgText (msgEntity) {
      console.log(msgEntity)
      if(!msgEntity) {
        return ''
      }
      if(msgEntity.type===0){
        return msgEntity.msg
      }
      if(msgEntity.type===2){
        return '[ 图片 ]'
      }
      if(msgEntity.type===3){
        return '[ 订单 ]'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-list{
  height: 100%;
  width:20vw;
}
.item{
  display: flex;
  position: relative;
  box-sizing: border-box;
  height: 110px;
  padding: 25px 15px;
  border-bottom: 0.5px solid #EDEDED;
  .item-avatar{
    display: inline-block;
    margin-right:8px;
    border-radius: 50%;
    width: 60px;
    height: 60px;
  }
  .item-msg{
    width: calc(100% - 68px);
  }
  .name{
    font-size: 20px;
  }
  .time{
    font-size: 14px;
    color: #B2B2B2;
  }
  .item-bottom{
    font-size: 16px;
    color: #999;
    word-break: break-all;
    width: calc(100% - 30px);
  }
  .item-unread{
    position: absolute;
    right:15px;
    bottom:25px;

    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
    border: 2px solid rgb(255, 255, 255);
    color: rgb(255, 255, 255);
    background-color: rgb(241, 64, 60);
    // padding: 2px 4px;
    padding-left: 4px;
    padding-right: 4px;
    // position: absolute;
    // bottom: 50%;
    // left: 50%;
    line-height: 1.35;
    font-size: 16px;
    border-radius: 20px;
  }
}
.search-bar{
  margin: 30px 15px;
}
::v-deep
.el-input{
  width: calc(100% - 30px)
}
</style>